export let SettingType;
(function (SettingType) {
  SettingType[SettingType["GANTT_WORKDAYS"] = 1] = "GANTT_WORKDAYS";
  SettingType[SettingType["RESOURCE_ALLOCATION"] = 2] = "RESOURCE_ALLOCATION";
  SettingType[SettingType["PROOFING_SETTINGS"] = 3] = "PROOFING_SETTINGS";
  SettingType[SettingType["USER_CARD_SETTINGS"] = 4] = "USER_CARD_SETTINGS";
  SettingType[SettingType["ADMIN_CARD_SETTINGS"] = 5] = "ADMIN_CARD_SETTINGS";
  SettingType[SettingType["SYS_ADMIN_SETTINGS"] = 6] = "SYS_ADMIN_SETTINGS";
  SettingType[SettingType["TEN_K_FEET_AVAILABILITY"] = 7] = "TEN_K_FEET_AVAILABILITY";
})(SettingType || (SettingType = {}));
//# sourceMappingURL=Grid.js.map